// extracted by mini-css-extract-plugin
export var label = "_fm-2";
export var slideContainer = "_fm-0";
export var slider = "_fm-1";